<template>
  <div id="connectUsPage" class="container-fluid">
    <v-main >
      <BackBar/>
      <div class="text-center font19px">
        <i class="fa-regular fa-phone fa-lg"></i>
        تماس با ما
      </div>
      <div class="row">
        <div class="col-12 ">
          <div class=" bg-white rounded-lg p-3 " >
            <div v-html="content">

            </div>
            <div class="primary-border-top py-3 mx-3 mt-3">
              <div>شبکه های اجتماعی</div>
              <div class="row">
                <div class="col-3 col-md-2 col-lg-1 text-center px-1" v-for="(item,i) in socialLinks" :key="i">
                  <a :href="item.Link" target="_blank">
                  <v-avatar size="60">
                    <img :src="$replaceHttps(item.FileUrl)" :alt="item.Name">
                  </v-avatar>
                  </a>
<!--                  <div class="mt-2">{{item.Name}}</div>-->
<!--                  <div>{{item.Description}}</div>-->

                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
export default {
  name: "ConnectUs",
  metaInfo: {
    title: 'ایوان خانه- تماس با ما',
  },
  components: {BackBar},
  data:()=>({
    content:null,
    socialLinks:[],
    showLoaderDialog:false
  }),
  mounted() {
    this.getData()
  },
  methods:{
    getData() {
      this.showLoaderDialog= true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Publicly/ContactUs", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.content = json.model.Description
              this.socialLinks=json.LocalSocialNetworkViewModel
            }
            this.showLoaderDialog= false
          })
          .catch(error => console.log('error', error));

    }
  }

}
</script>
